import React from "react";
import * as Animate from "react-reveal";
import GroupPhoto from "../../../assets/images/png/global-mba-graduation-group-v1.webp";
import ConversationPhoto from "../../../assets/images/png/mba/global-mba-graduation-conversation-v1.jpg";

const MBAGraduationSection = () => {
  return (
    <section
      className="bg-primary text-white py-16 md:py-24 lg:py-28 px-4"
      aria-labelledby="graduation-heading"
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-mba-heading gap-10 lg:gap-16 items-end mb-10 lg:mb-12">
          <Animate.Fade bottom>
            <div>
              <p className="flex items-center gap-3 font-poppins text-secondary text-sm font-extrabold tracking-widest uppercase mb-5">
                <span className="w-8 h-0.5 bg-secondary inline-block flex-shrink-0"></span>
                The graduation moment
              </p>
              <h2
                id="graduation-heading"
                className="font-poppins text-white font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl leading-tight max-w-2xl m-0"
              >
                Wear the work. Celebrate the next chapter.
              </h2>
            </div>
          </Animate.Fade>
          <Animate.Fade bottom>
            <p className="font-poppins text-blue-100 text-sm leading-loose m-0">
              The Utiva Global MBA sash marks a practical journey—from stronger
              business judgement to a global community of ambitious leaders.
            </p>
          </Animate.Fade>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-mba-graduation-photos gap-4">
          <Animate.Fade bottom>
            <figure className="relative m-0 rounded-3xl overflow-hidden h-[390px] sm:h-[510px] bg-primary2">
              <img
                src={GroupPhoto}
                alt="Illustrative group of African professionals wearing Utiva Global MBA graduation sashes"
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <span
                className="absolute inset-x-0 bottom-0 h-[35%] bg-gradient-to-t from-black/70 to-transparent"
                aria-hidden="true"
              ></span>
              <figcaption className="absolute left-6 right-6 bottom-6 flex items-center gap-3">
                <span className="font-poppins text-secondary font-extrabold text-sm">
                  01
                </span>
                <strong className="font-poppins text-sm font-semibold">
                  A milestone built for the next chapter.
                </strong>
              </figcaption>
            </figure>
          </Animate.Fade>

          <Animate.Fade bottom>
            <figure className="relative m-0 rounded-3xl overflow-hidden h-[390px] sm:h-[510px] bg-primary2">
              <img
                src={ConversationPhoto}
                alt="Illustrative African professionals in conversation wearing Utiva Global MBA graduation sashes"
                loading="lazy"
                className="w-full h-full object-cover object-center"
              />
              <span
                className="absolute inset-x-0 bottom-0 h-[35%] bg-gradient-to-t from-black/70 to-transparent"
                aria-hidden="true"
              ></span>
              <figcaption className="absolute left-6 right-6 bottom-6 flex items-center gap-3">
                <span className="font-poppins text-secondary font-extrabold text-sm">
                  02
                </span>
                <strong className="font-poppins text-sm font-semibold">
                  Leadership confidence, earned in practice.
                </strong>
              </figcaption>
            </figure>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
};

export default MBAGraduationSection;
